import { z } from 'zod';

// Minimal zod contract for GET /api/v2/bizy/people/moments/:observedMomentId
// (the "owned moment" cold-open fetch). Mirrors the fields onboarding needs
// from `BizyOwnedObservedMomentResponse` in `src/lib/bizy/types/people.ts` —
// extra keys the endpoint returns are simply ignored by the parse.

export const BizyOwnedMomentPerson = z.object({
	id: z.string(),
	name: z.string().nullish(),
	avatarUrl: z.string().nullish(),
});

export type BizyOwnedMomentPerson = z.infer<typeof BizyOwnedMomentPerson>;

export const BizyOwnedMoment = z.object({
	person: BizyOwnedMomentPerson,
	moment: z.object({
		id: z.string(),
		/** Bold headline text (BIZY-662); `moment` is the regular body below it. */
		headline: z.string().nullish(),
		moment: z.string().nullish(),
		source: z.string().nullish(),
	}),
});

export type BizyOwnedMoment = z.infer<typeof BizyOwnedMoment>;

export const bizyOwnedMomentFixture = (overrides: Partial<BizyOwnedMoment> = {}): BizyOwnedMoment => ({
	person: { id: 'person-1', name: 'Alex Kim', avatarUrl: null },
	moment: {
		id: 'moment-1',
		headline: 'Shipped the release crunch',
		moment: 'Alex jumped in on the release crunch last week and kept everything on track.',
		source: 'slack',
	},
	...overrides,
});
